export default __webpack_public_path__ + "static/media/first-national.d8623c91.png";